export default __webpack_public_path__ + "static/media/stopwatch-icon.1a226d34.svg";